import {GradientBorderWrapper, GradientInput} from "./gradientInput.styled";
import {useState} from "react";
import {TextFieldProps} from "@mui/material";

interface UiGradientInputProps extends Omit<TextFieldProps, 'variant'> {
  borderRadius?: string
  boxShadow?: string
}

export function UiGradientInput (props: UiGradientInputProps) {
  const [focused, setFocused] = useState<boolean>(false)
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <GradientBorderWrapper
      borderRadius={props.borderRadius}
      focused={focused}
      hovered={hovered}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <GradientInput
        boxShadow={props.boxShadow}
        {...props}
        onFocus={(e) => {
          setFocused(true)
          props.onFocus?.(e)
        }}
        onBlur={(e) => {
          setFocused(false)
          props.onBlur?.(e)
        }}
      />
    </GradientBorderWrapper>
  )
}